import { TOASTER, LOADER, DATE_RANGEPICKER, SEARCH_QUERY } from "../../resources/actionTypes";

const initialSettings = {
  showToaster: {type: "success", message: "Hi Hello"},
  showLoader: false,
  selectedRange: "",
  searchedParams: ""
};

export const commonReducer = (state, action) => {
  if (typeof state === "undefined") {
    return initialSettings;
  }
  switch (action.type) {
    case TOASTER.TOASTER_SHOW:
      return {
        ...state,
        showToaster: action.payload,
      };
    case LOADER.LOADER_SHOW:
      return {
        ...state,
        showLoader: action.payload,
      };
      case DATE_RANGEPICKER.DATE_RANGEPICKER_VALUE:
      return {
        ...state,
        selectedRange: action.payload,
      };
      case SEARCH_QUERY.SEARCH_QUERY_VALUE:
        return {
          ...state,
          searchedParams: action.payload,
        };
    default:
      return state;
  }
};
